import { getApiBookingIdQueryKey, usePostApiBookingIdCancel } from '@barbershop/api/customer'
import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export const useCancelBooking = () => {
    const queryClient = useQueryClient()

    const { mutateAsync: cancelBooking, isPending } = usePostApiBookingIdCancel({
        mutation: {
            onSuccess: async (_, { id, params }) => {
                await queryClient.invalidateQueries({
                    queryKey: getApiBookingIdQueryKey(id, params),
                })
                toast.success('Запись успешно отменена')
            },
            onError: () => {
                toast.error('Ошибка при отмене записи')
            },
        },
    })

    return {
        cancelBooking,
        isPending,
    }
}
